// extracted by mini-css-extract-plugin
export default {"root":"ButtonSvgIcon-root-3dc1fafe49c55a8ced1e83aef8a1d61e"};